import { useCallback, useState, useEffect } from 'react';
import { GetSymbolListQueryVariables, useGetSymbolListQuery } from 'views/utils/graphql/graphql';

export const useGetSymbolList = (initVariables: GetSymbolListQueryVariables) => {
  const [symbolName, setSymbolName] = useState<string>(initVariables.symbolName || '');
  const [currentPage, setCurrentPage] = useState<number>(initVariables.page);

  const [symbolListVariables, setSymbolListVariables] = useState<GetSymbolListQueryVariables>(initVariables);
  const [getSymbolListState, getSymbolList] = useGetSymbolListQuery({
    variables: symbolListVariables,
    requestPolicy: 'network-only',
  });

  const [showLoading, setShowLoading] = useState<boolean>(false);
  useEffect(() => {
    if (getSymbolListState.fetching) {
      setShowLoading(true);
    } else {
      setShowLoading(false);
    }
  }, [getSymbolListState]);

  // 銘柄名のセットと同時に検索する
  // setSymbolNameは一時的に保存する場合で検索は同時に行わない
  const setSymbolNameWithFetch = useCallback(
    (newSymbolName: string) => {
      setSymbolName(newSymbolName);
      //銘柄名を変更する場合は必ず1ページ目に戻る
      setCurrentPage(1);
      setSymbolListVariables((state) => ({
        ...state,
        symbolName: newSymbolName,
        page: 1,
      }));
    },
    [setSymbolName, setCurrentPage],
  );

  // ページ変更の場合は即時に検索する
  useEffect(() => {
    setSymbolListVariables((state) => ({
      ...state,
      page: currentPage,
    }));
  }, [currentPage]);

  return {
    symbolName,
    setSymbolName,
    currentPage,
    setCurrentPage,
    setSymbolNameWithFetch,
    getSymbolListState,
    showLoading,
  };
};
